<template>
  <div class="home">
    <!-- 轮播图 -->
    <div v-wechat-title="$route.meta.title"></div>
    <div v-scroll:throttle="{fn: onScroll, throttle: 500 }" style="overflow: auto;height:100vh;">
      <div class="block">
        <el-carousel trigger="click" height="954px">
          <el-carousel-item>
            <img src="../assets/banner1.jpg" alt class="banner_img" />
          </el-carousel-item>
        </el-carousel>
        <div class="wx_position" @click="onImg">
          <img src="../assets/wx.png" alt />
        </div>
        <div class="search_position" @click="onReturnTop">
          <span>探索</span>
        </div>
      </div>
      <!-- 弹框 -->
      <el-dialog :visible.sync="dialogVisible" width="30%">
        <div>
          <!-- <div class="dialog_title">扫码关注</div> -->
          <div class="dialog_img">
            <img src="../assets/erweima.png" alt />
          </div>
          <div class="dialog_title2">打开微信扫一扫</div>
          <div class="dialog_title1">即可关注升学地图</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 头部 -->
      <div class="header" :class="position.scrollTop >= 800 ? 'bg_activite' : ''">
        <div class="header_list">
          <img src="../assets/logo.png" alt />
        </div>
        <div>
          <el-dropdown @command="handleCommand">
            <img src="../assets/logo_right.png" alt />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">升学地图</el-dropdown-item>
              <el-dropdown-item command="b">更多产品</el-dropdown-item>
              <el-dropdown-item command="c">热点资讯</el-dropdown-item>
              <el-dropdown-item command="d">关于我们</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 第二部分 -->
      <div class="countainer" id="countainer">
        <div class="countainer_box">
          <div class="countainer_box_title">升学地图-让孩子的升学路径跃然图上</div>
          <div class="countainer_box_desc">一键定制、省时、省事</div>
          <div class="countainer_box_desc1">孩子的升学路径一目了然</div>
          <div class="countainer_box_img">
            <div class="count_img" @mouseover="mouseover(0)" @mouseleave="mouseleave(0)">
              <img src="../assets/detail.png" style="width:100%" alt />
              <div>
                <p class="count_img_title">一键定制升学路径地图</p>
                <p class="count_img_desc">信息多、工作忙、孩子升学怎么办？</p>
                <p class="count_img_desc">Only 30秒，一键定制属于你的个性化升学地图</p>
              </div>
              <!-- 蒙层 -->
              <div class="count_activite" v-show="isShow">
                <img src="../assets/erweima.png" alt />
                <p>关注小程序了解更多</p>
                <p>微信扫一扫关注公众号</p>
              </div>
            </div>
            <div class="count_img" @mouseover="mouseover(1)" @mouseleave="mouseleave(1)">
              <img src="../assets/detail2.png" style="width:100%" alt />
              <div>
                <p class="count_img_title">个性化自主查询</p>
                <p class="count_img_desc">查政策、查学区房、查入学</p>
                <p class="count_img_desc">手指一动、应有尽有。</p>
              </div>
              <!-- 蒙层 -->
              <div class="count_activite" v-show="isStatus">
                <img src="../assets/erweima.png" alt />
                <p>关注小程序了解更多</p>
                <p>微信扫一扫关注公众号</p>
              </div>
            </div>
            <div class="count_img" @mouseover="mouseover(2)" @mouseleave="mouseleave(2)">
              <img src="../assets/detail3.png" style="width:100%" alt />
              <div>
                <p class="count_img_title">疑难问题，专家解答，和千万家长热议开学那些事</p>
                <p class="count_img_desc">专家在线，热门问题详细解答</p>
                <p class="count_img_desc">群友交流，疑难杂症及时解决</p>
              </div>
              <!-- 蒙层 -->
              <div class="count_activite" v-show="isActivite">
                <img src="../assets/erweima.png" alt />
                <p>关注小程序了解更多</p>
                <p>微信扫一扫关注公众号</p>
              </div>
            </div>
          </div>
        </div>
        <div class="news" id="news">
          <!-- <div class="countainer_box_title">升学地图-热点资讯</div> -->
          <div class="news_box1">
            <div class="news_detail">
              <div class="news_detail_ul">
                <h2 class="news_detail_title">使用升学地图小程序</h2>
                <p class="news_detail_li">1.打开微信扫一扫二维码</p>
                <p class="news_detail_li">2.定制孩子的私人升学路径</p>
                <p class="news_detail_li">3.疑难解答，家长群交流</p>
                <p class="news_detail_li">4.更多个性化工具</p>
                <!-- <ul>
                  <li></li>
                  <li>2.定制孩子的私人升学路径</li>
                  <li>3.疑难解答，家长群交流</li>
                  <li>4.更多个性化工具</li>
                </ul>-->
              </div>
              <div style="width:100%;text-align: center;">
                <img src="../assets/erweima.png" style="margin:0 auto;padding-top:30px;" alt />
              </div>
            </div>
            <div class="news_detail">
              <div class="news_detail_f1">热点信息</div>
              <div
                class="news_detail_f1_box"
                @click="onRouterPush(item.Id)"
                v-for="(item,index) in newsList"
                :key="item.Id"
              >
                <div class="news_detail_index">{{index+1}}</div>
                <div class="news_detail_count">{{item.Title}}</div>
                <div style="padding-right:38px">{{item.Hits}}</div>
              </div>
              <!-- <div class="block">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="PageIndex"
                  :page-size="PageSize"
                  layout="total, prev, pager, next"
                  :total="totalCount"
                ></el-pagination>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="fotter" id="fotter">
        <div class="fotter_erweima">
          <img src="../assets/erweima.png" alt />
          <p class="fotter_erweima_phone">微信公众号</p>
          <p class="fotter_erweima_phone1">客服热线：021-8031-3322</p>
        </div>
        <div class="fotter_right">
          <div class="fotter_right_chanpin">
            <h2 class="fotter_right_title">更多产品</h2>
            <ul class="fotter_right_ul" style="margin-left:10px;">
              <li>壹志愿</li>
              <li>壹培优</li>
              <li>蘑菇岛</li>
              <li>蘑菇家长</li>
            </ul>
          </div>
          <div class="fotter_right_chanpin">
            <h2 class="fotter_right_title">关于我们</h2>
            <ul class="fotter_right_ul">
              <li>
                <img src="../assets/web.png" alt />
                <a href="https://www.yrtsedu.cn/">https://www.yrtsedu.cn/</a>
              </li>
              <li>
                <img src="../assets/web.png" alt />
                上海市金沙江路1628弄1号楼·11F
              </li>
            </ul>
          </div>
        </div>
        <div class="fotter_bottom">©2020 上海跃然图上教育科技有限公司 沪ICP备20018345号</div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  data() {
    return {
      dialogVisible: false,
      Scroll: 0,
      position: { scrollTop: 0, scrollLeft: 0 },
      isShow: false,
      isStatus: false,
      isActivite: false,
      PageIndex: 1,
      PageSize: 10,
      totalCount: 10,
      newsList: [],
    };
  },
  created() {
    this.__init();
  },
  methods: {
    handleCurrentChange(val) {
      console.log(val);
      this.$set(this.newsList, "PageIndex", val);
    },
    // 获取新闻资讯列表
    __init() {
      this.axios
        .get(
          "http://39.106.227.197:8000/api/WebSite_FurtherEducation_News/GetNewsList",
          {
            params: {
              PageIndex: this.PageIndex,
              PageSize: this.PageSize,
            },
          }
        )
        .then((res) => {
          // console.log(res.data.,'---');
          this.newsList = res.data.response.data;
          this.totalCount = res.data.response.dataCount;
        });
    },
    // 页面跳转
    onRouterPush(id) {
      this.$router.push({
        name: "About",
        params: {
          id: id,
        },
      });
    },
    // 描点定位
    onReturnTop() {
      document.querySelector("#countainer").scrollIntoView({
        behavior: "smooth", // 平滑过渡
      });
    },
    handleCommand(command) {
      switch (command) {
        case "d":
          document.querySelector("#fotter").scrollIntoView({
            behavior: "smooth", // 平滑过渡
          });
          break;
        case "c":
          document.querySelector("#news").scrollIntoView({
            behavior: "smooth", // 平滑过渡
          });
          break;
      }
    },
    onImg() {
      this.dialogVisible = true;
    },
    onScroll(e, position) {
      console.log(e, position);
      this.position = position;
    },
    // 鼠标移入
    mouseover(index) {
      switch (index) {
        case 0:
          this.isShow = true;
          break;
        case 1:
          this.isStatus = true;
          break;
        case 2:
          this.isActivite = true;
          break;
      }
    },
    mouseleave(index) {
      switch (index) {
        case 0:
          this.isShow = false;
          break;
        case 1:
          this.isStatus = false;
          break;
        case 2:
          this.isActivite = false;
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bg_activite {
  background: #5ea1fb;
  transition: all 0.3s;
}
.fotter {
  width: 100%;
  height: 480px;
  background: url("../assets/fotter.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  margin-top: 60px;
  .fotter_bottom {
    position: absolute;
    bottom: 25px;
    left: 0;
    right: 0;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }
  .fotter_erweima {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 50%;
    // border: 1px solid red;
    .fotter_erweima_phone {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #ffffff;
      padding-top: 25px;
    }
    .fotter_erweima_phone1 {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #ffffff;
      padding-top: 12px;
    }
  }
  .fotter_right {
    width: 50%;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    justify-content: center;
    .fotter_right_chanpin {
      // width: 300px;
      // text-align: center;
      // border: 1px solid red;
      height: 300px;
      margin: 0 auto;
      .fotter_right_title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 600;

        color: #ffffff;
      }
      .fotter_right_ul {
        li {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          padding: 10px 0 20px 0;
          a {
            color: #ffffff;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
.countainer {
  width: 100%;
  .news {
    max-width: 1200px;
    margin: 0 auto;
    // height: 400px;
    .countainer_box_title {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5da1fb;
      text-align: center;
      padding-top: 90px;
    }
    .news_box1 {
      display: flex;
      justify-content: space-between;
      .news_detail {
        width: 510px;
        height: 485px;
        margin: 10px;
        // border: 1px solid red;
        position: relative;
        background: #ffffff;
        box-shadow: 1px 8px 14px 0px rgba(94, 162, 251, 0.1);
        border-radius: 10px;
        position: relative;
        .block {
          position: absolute;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
        }
        .news_detail_f1 {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #343434;
          padding: 20px;
        }
        .news_detail_f1_box {
          width: auto;
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-around;
          padding: 10px;
          .news_detail_index {
            width: 20px;
            height: 20px;
            background: red;
            color: #fff;
            text-align: center;
            line-height: 20px;
            margin-left: 38px;
          }
          .news_detail_count {
            // width: 342px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            width: 360px;
            color: #343434;
            padding-left: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .news_detail_title {
          font-size: 28rpx;
          font-family: PingFang SC;
          font-weight: 600;
          color: #343434;
          text-align: center;
          padding-top: 25px;
        }
        .news_detail_ul {
          .news_detail_li {
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #343434;
            margin-top: 20px;
            padding-left: 140px;
          }
          li {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #343434;
            padding-top: 15px;
          }
          ul li {
            list-style: none;
          }
        }
      }
    }
  }
  .countainer_box {
    max-width: 1200px;
    margin: 0 auto;

    .countainer_box_title {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5da1fb;
      text-align: center;
      padding-top: 90px;
    }
    .countainer_box_desc {
      width: 802px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #5ea2fb;
      line-height: 24px;
      text-align: center;
      margin: 0 auto;
      padding-top: 24px;
      letter-spacing: 5px;
    }
    .countainer_box_desc1 {
      width: 802px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #5ea2fb;
      line-height: 24px;
      text-align: center;
      margin: 0 auto;
      // padding-top: 15px;
      letter-spacing: 5px;
    }
  }
  .countainer_box_img {
    display: flex;
    justify-content: space-around;
    padding-top: 16px;
    .count_img {
      width: 385px;
      // height: 405px;
      // border: 1px solid red;
      margin: 10px;
      position: relative;
      background: #ffffff;
      box-shadow: 0px 8px 14px 0px rgba(93, 161, 251, 0.1);
      border-radius: 10px;
      .count_activite {
        position: absolute;
        top: 0;
        background: #333;
        opacity: 0.8;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: all 0.3s;
        p {
          color: #fff;
          font-size: 20px;
          font-weight: 500;
          margin-top: 10px;
        }
      }
      .count_img_title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #343434;
        padding: 20px;
        white-space: nowrap;

        overflow: hidden;

        text-overflow: ellipsis;
      }
      .count_img_desc {
        padding-left: 20px;
        padding-bottom: 10px;
        // font-size: 16px;
        // font-family: PingFang SC;
        // font-weight: 400;
        // color: #343434;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;

        span {
          color: #fe4141;
        }
      }
    }
  }
}
.dialog_img {
  text-align: center;
  img {
    width: 254px;
    height: 251px;
  }
}
.dialog_title {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #5ea2fb;
  text-align: center;
  padding: 20px;
}
.dialog_title1 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #5ea2fb;
  text-align: center;
}
.dialog_title2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #5ea2fb;
  text-align: center;
}
.block {
  position: relative;
  .wx_position {
    position: absolute;
    left: 363px;
    bottom: 87px;
    z-index: 99;
    img {
      width: 51px;
      height: 41px;
    }
  }
  .search_position {
    position: absolute;
    bottom: 98px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 140px;
    height: 50px;
    border: 2px solid #ffffff;
    opacity: 0.7;
    border-radius: 10px;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    span {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 126px;
  // background: #5ea1fb;
  // opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 99;
}
.banner_img {
  width: 100%;
}
// .el-carousel__item h3 {
//   color: #475669;
//   font-size: 14px;
//   opacity: 0.75;
//   line-height: 150px;
//   margin: 0;
// }

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
</style>